import CustomApplicationState from "@aihCustomBlueprint/Store/CustomApplicationState";
import ProductSubscribeState from "@aihCustomBlueprint/Store/Data/AihCustomProductSubscribe/ProductSubscribeState";

export const getProductStatusMultiSelector = (
    state: CustomApplicationState,
): ProductSubscribeState["productStatusMulti"] => state.AIHState?.ProductSubscriptions?.productStatusMulti;

export const getAllSubscribedProductsSelector = (
    state: CustomApplicationState,
): ProductSubscribeState["subscribedProducts"] => state.AIHState?.ProductSubscriptions?.subscribedProducts;
